import { render, staticRenderFns } from "./quotationprice.vue?vue&type=template&id=63029d33&scoped=true"
import script from "./quotationprice.vue?vue&type=script&lang=js"
export * from "./quotationprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63029d33",
  null
  
)

export default component.exports